// Modified by Sullivan Digital, 2026-10-26: "Pro" gem badges render nothing (SALDP white-labelling). Licensed under the GNU AGPL v3.
import { Icon, type IconProps } from "metabase/ui";

import S from "./UpsellGem.module.css";
import { removedUpsell } from "./removed-upsell";

const _UpsellGem = (props: Omit<IconProps, "name" | "color">) => (
  <Icon
    data-testid="upsell-gem"
    size={16}
    name="gem"
    className={S.UpsellGem}
    {...props}
  />
);

const UpsellGemNew = (props: Omit<IconProps, "name" | "color">) => (
  <Icon
    data-testid="upsell-gem"
    size={16}
    name="gem"
    className={S.UpsellGemNew}
    {...props}
  />
);

export const UpsellGem = Object.assign(removedUpsell(_UpsellGem), {
  New: removedUpsell(UpsellGemNew),
});
